import { pathWithBasename } from 'utils/pathWithBasename';

import { getMiurosMfeView } from '../components/getMiurosMfeView';

export const MiurosBiMfeView = getMiurosMfeView(
  'bi',
  pathWithBasename('/analytics/intelligence/'),
);
